// Optimizely feature flags consumed by this web app.
export const PDPExpressCheckout = {
  NAME: 'pdp_express_checkout',
  VARIANT: 'variant',
} as const;
